// extracted by mini-css-extract-plugin
module.exports = {"desktopOnly":"CombinedMenu_desktopOnly__1I6Ls","mobileOnly":"CombinedMenu_mobileOnly__XhAuX"};